// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1R443","col":"styles_col__1qhrR"};